import { isModernBridge } from '@/common/bridge/mode';

import * as CommsService from '../comms.service';
import { CommsCommand } from '../comms.enum';

/**
 * Emit the `on_chat:end` event to the host page when the visitor ends a live chat
 * session (user-initiated end or idle timeout). Not emitted when closing/minimizing
 * the widget. No-op outside modern SDK bridge mode.
 */
export function emitChatEnd(): void {
  if (!isModernBridge()) {
    return;
  }

  CommsService.post(CommsCommand.emit.chatEnd);
}
